import axios from 'axios';
import baseUrl from '../BaseURL';

// Apply credentials only to our API. Tokens stay in React memory; the browser
// sends the server's HttpOnly cookie, including when loading a refreshed tab.
export function configureApiAuth(client = axios) {
  const apiOrigin = new URL(baseUrl, window.location.origin).origin;
  const request = client.interceptors.request.use(config => {
    const url = new URL(config.url, config.baseURL || window.location.origin);
    if (url.origin === apiOrigin && /^\/(auth|free)(\/|$)/.test(url.pathname)) {
      config.withCredentials = true;
      config.headers = config.headers || {};
      config.headers['X-FIN-Request'] = '1';
    }
    return config;
  });
  const response = client.interceptors.response.use(result => result, error => {
    const url = new URL(error.config?.url || '/', error.config?.baseURL || window.location.origin);
    if (error.response?.status === 401 && url.origin === apiOrigin && /^\/auth(\/|$)/.test(url.pathname)) {
      window.dispatchEvent(new Event('fin-auth-expired'));
    }
    return Promise.reject(error);
  });
  return () => { client.interceptors.request.eject(request); client.interceptors.response.eject(response); };
}
